export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-graph-horizontal-d4d175f86938f21c8799fd454be405f8.svg";